/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Myaccess2Inputs */

const en_navtitles_myaccess2 = /** @type {(inputs: Navtitles_Myaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My access`)
};

/**
* | output |
* | --- |
* | "My access" |
*
* @param {Navtitles_Myaccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_myaccess2 = /** @type {((inputs?: Navtitles_Myaccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Myaccess2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_myaccess2(inputs)
});
export { navtitles_myaccess2 as "navTitles_myAccess" }